import { NgZone } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { BusinessPromoForReportRunsComponent } from '../components/business-promo-for-report-runs/business-promo-for-report-runs-component';
import { BusinessPromoForSpacesComponent } from '../components/business-promo-for-spaces/business-promo-for-spaces-component';
import { ChartRenderer2Component } from '../components/chart/chart-renderer2.component';
import { CopyLinkToVizDirective } from '../components/copy-link-to-viz/copy-link-to-viz-directive';
import { DatasetGridComponent } from '../components/dataset-grid/dataset-grid.component';
import { ModeDatePickerDirective } from '../components/date-picker/date-picker-directive';
import { DbtDetailsTableComponent } from '../components/dbt-details-table/dbt-details-table.component';
import { DocBlur } from '../components/doc-blur/doc-blur';
import { FieldTreeViewComponent } from '../components/field-tree-view/field-tree-view-component';
import { FilterModuleMultiComponent } from '../components/filter-module-multi/filter-module-multi-component';
import { FilterModuleRangeComponent } from '../components/filter-module-range/filter-module-range-component';
import { FilterModuleSingleComponent } from '../components/filter-module-single/filter-module-single-component';
import { FilterPanelTogglerComponent } from '../components/filter-panel-toggler/filter-panel-toggler-component';
import { CustomSelectDropdownComponent } from '../components/form-elements/custom-select-dropdown.component';
import { RadioComboInputComponent } from '../components/form-elements/radio-combo-input.component';
import { RadioPlusStringInputComponent } from '../components/form-elements/radio-plus-string-input.component';
import { FormatSettingsComponent } from '../components/format-settings/format-settings';
import { InPlaceEditDirective } from '../components/in-place-edit/in-place-edit-directive';
import { InsertFilterModalTriggerDirective } from '../components/modal-insert-filter/insert-filter-modal-trigger-directive';
import { ModalSelectQueryComponent } from '../components/modal-select-query/modal-select-query.component';
import { PlatformHeaderNavPanelComponent } from '../components/platform-header-nav-panel/platform-header-nav-panel-component';
import { PlatformHeaderNavPanelComponentFacade } from '../components/platform-header-nav-panel/platform-header-nav-panel-component.facade';
import { ReportBuilderComponent } from '../components/report-builder/report-builder.component';
import { tableGridDirective } from '../components/table/table-grid-directive';
import { TreeViewItemComponent } from '../components/tree-view-item/tree-view-item-component';
import { TreeViewComponent } from '../components/tree-view/tree-view-component';
import { SharedUiModule } from './shared-ui/shared-ui.module';

import { GithubFeatureSyncModalAngularJsModule } from '@mode/github/feature-sync-modal-angularjs';
import { dropdownAutoOrient } from '../components/dropdown/dropdown-auto-orient-directive';
import { DowngradedAccountsFeatureHeaderModule } from './downgraded-angular/accounts/feature-header.module';
import { DowngradedAccountsUIModule } from './downgraded-angular/accounts/ui.module';
import { DowngradedAngularCoreModule } from './downgraded-angular/angular/core.module';
import { DowngradedCapraModule } from './downgraded-angular/capra/components.module';
import { DowngradedCollectionsFeatureManageAccessModule } from './downgraded-angular/collections/feature-manage-access.module';
import { DowngradedDatasetFeatureHeaderModule } from './downgraded-angular/dataset/feature-header.module';
import { DowngradedGithubUIModule } from './downgraded-angular/github/ui.module';
import { DowngradedReportEditorShellModule } from './downgraded-angular/report-editor/shell.module';
import { DowngradedReportViewerPdfExportApiModule } from './downgraded-angular/report-viewer/pdf-export/api.module';
import { DowngradedReportsUIModule } from './downgraded-angular/reports/ui.module';
import { DowngradedSharedEnvironmentContract } from './downgraded-angular/shared/environment-contract.module';
import { DowngradedSharedFeatureErrorPagesModule } from './downgraded-angular/shared/feature-error-pages.module';
import { DowngradedSharedUIModule } from './downgraded-angular/shared/ui.module';
import { NotebookSecretFacade } from '@mode/notebooks/contract';
import { DowngradedUtilThoughtspotIntegratedModule } from '~/modules/downgraded-angular/shared/util-thoughtspot-integrated.module';
import { MetaTagsService } from '@mode/shared/util-js';
import { MoveSpacePublishService } from '@mode/dataset/domain';

angular
  .module('mode.components', [
    'asyncFilter',
    'ngSanitize',
    'ngCookies',
    'ngDrag',
    'ui.bootstrap.contextMenu',
    'ui.bootstrap.datepicker',
    'ui.bootstrap.accordion',
    'ui.select',
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    SharedUiModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedUIModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedGithubUIModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedCapraModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedAngularCoreModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedCollectionsFeatureManageAccessModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedAccountsFeatureHeaderModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedFeatureErrorPagesModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedReportsUIModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedAccountsUIModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedReportEditorShellModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedReportViewerPdfExportApiModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedDatasetFeatureHeaderModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedUtilThoughtspotIntegratedModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedEnvironmentContract,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    GithubFeatureSyncModalAngularJsModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
  ])
  .component('formatSettings', FormatSettingsComponent)
  .component('fieldTreeView', FieldTreeViewComponent)
  .component('treeView', TreeViewComponent)
  .component('treeViewItem', TreeViewItemComponent)
  .constant('ace', window['ace'])
  .component('filterPanelToggler', FilterPanelTogglerComponent)
  .directive('docBlur', DocBlur)
  .directive('insertFilterModalTrigger', InsertFilterModalTriggerDirective)
  .directive('modeTable', tableGridDirective)
  .directive('modeDatePicker', ModeDatePickerDirective)
  .directive('inPlaceEdit', InPlaceEditDirective)
  .directive('copyLinkToViz', CopyLinkToVizDirective)
  .component('dbtDetailsTable', DbtDetailsTableComponent)
  .component('filterModuleSingle', FilterModuleSingleComponent)
  .component('filterModuleMulti', FilterModuleMultiComponent)
  .component('filterModuleRange', FilterModuleRangeComponent)
  .component('platformHeaderNavPanel', PlatformHeaderNavPanelComponent)
  .component('businessPromoForReportRuns', BusinessPromoForReportRunsComponent)
  .component('businessPromoForSpaces', BusinessPromoForSpacesComponent)
  .component('reportBuilder', ReportBuilderComponent)
  .component('chartRendererToo', ChartRenderer2Component)
  .component('datasetGrid', DatasetGridComponent)
  .component('modalSelectQuery', ModalSelectQueryComponent)
  .component('radioComboInput', RadioComboInputComponent)
  .component('radioPlusStringInput', RadioPlusStringInputComponent)
  .component('customSelectDropdown', CustomSelectDropdownComponent)
  .directive('dropdownAutoOrient', dropdownAutoOrient)
  .service('NotebookSecretFacade', downgradeInjectable(NotebookSecretFacade))
  .service('PlatformHeaderNavPanelComponentFacade', downgradeInjectable(PlatformHeaderNavPanelComponentFacade))
  .service('MetaTagsService', downgradeInjectable(MetaTagsService))
  .service('MoveSpacePublishService', downgradeInjectable(MoveSpacePublishService))
  .filter('decodeURIComponent', () => decodeURIComponent); // necessary because Angular https://stackoverflow.com/a/16630601

(function () {
  const ngDragEventDirectives = {};

  /*
    This is where we dynamically define the
    ngDrag, ngDragend, ngDragenter, ngDragexit, ngDragleave, ngDragstart, ngDrop directives
   */
  angular.forEach('drag dragend dragenter dragexit dragleave dragstart drop'.split(' '), function (eventName) {
    const directiveName = 'ng' + eventName.charAt(0).toUpperCase() + eventName.slice(1);

    ngDragEventDirectives[directiveName] = [
      '$parse',
      function ($parse) {
        return {
          restrict: 'A',
          compile: function ($element, attr) {
            const fn = $parse(attr[directiveName], null, true);

            return function ngDragEventHandler(scope, element) {
              element[0].addEventListener(eventName, function (event) {
                const callback = function () {
                  fn(scope, { $event: event });
                };

                scope.$apply(callback); // has to be $apply due to timing constraints
              });
            };
          },
        };
      },
    ];
  });

  angular
    .module('ngDrag', [DowngradedAngularCoreModule])
    .directive(ngDragEventDirectives)
    .directive('ngDragover', [
      '$parse',
      'NgZone',
      function ($parse, ngZone: NgZone) {
        return {
          restrict: 'A',
          compile: function ($element, attr) {
            const fn = $parse(attr['ngDragover'], null, true);

            return function ngDragEventHandler(scope, element) {
              ngZone.runOutsideAngular(() => {
                element[0].addEventListener('dragover', function (event) {
                  const callback = function () {
                    fn(scope, { $event: event });
                  };

                  callback(); // No digest since dragover is called so much
                });
              });
            };
          },
        };
      },
    ]);
})();
